import api from './api';

export interface AgentOption {
  id: string;
  name: string;
  description: string;
  avatar: string;
}

export interface NarrativeOption {
  value: string;
  label: string;
  description: string;
}

export interface ModelTierOption {
  value: string;
  label: string;
  description: string;
}

export interface SettingsOptions {
  agents: AgentOption[];
  narrative_styles: NarrativeOption[];
  model_tiers: ModelTierOption[];
}

export interface UserSettings {
  user_id?: string;
  preferred_agent: string;
  narrative_style: 'formal' | 'friendly';
  model_tier: 'cheap' | 'balanced' | 'expensive';
}

const settingsService = {
  async getSettingsOptions(): Promise<SettingsOptions> {
    const response = await api.get('/api/chatbot/settings/options');
    return response.data;
  },

  async getUserSettings(): Promise<UserSettings> {
    const response = await api.get('/api/chatbot/settings');
    return response.data;
  },

  async saveUserSettings(settings: UserSettings): Promise<UserSettings> {
    const response = await api.post('/api/chatbot/settings', settings);
    return response.data;
  }
};

export default settingsService;